const termsOfServiceContent = {
  title: "Terms of Service",
  effectiveDate: "21 February 2026",
  sections: [
    {
      heading: "1. Introduction",
      content: `
Welcome to the website of Parimitra Pvt. Ltd. These Terms of Service govern your access to and use of our website and any information, materials, or services made available through it. By accessing, browsing, or using this website, you acknowledge that you have read, understood, and agreed to be legally bound by these Terms of Service.

If you do not agree with any part of these terms, you must discontinue use of the website immediately. Continued use of the website constitutes acceptance of these terms and any future modifications.
      `
    },
    {
      heading: "2. Use of Website",
      content: `
This website is provided for informational purposes and to enable communication with Parimitra Pvt. Ltd. regarding our services, case studies, and business offerings. You agree to use the website in a lawful, ethical, and responsible manner at all times.

You may not use the website in any way that violates applicable laws or regulations, infringes on the rights of others, attempts to gain unauthorized access to systems or data, interferes with website functionality, or introduces malicious code. We reserve the right to restrict or terminate access to users who misuse the website or violate these Terms.
      `
    },
    {
      heading: "3. Intellectual Property",
      content: `
All content available on this website, including but not limited to text, graphics, designs, branding elements, logos, case studies, visual materials, software components, and overall website structure, is the intellectual property of Parimitra Pvt. Ltd. unless otherwise stated. Such content is protected under applicable copyright, trademark, and intellectual property laws.

You may view and access the website for personal or informational purposes only. Any reproduction, distribution, modification, republication, transmission, or commercial use of website content without prior written consent from Parimitra Pvt. Ltd. is strictly prohibited.
      `
    },
    {
      heading: "4. User Submissions",
      content: `
Any information submitted through our contact forms or other communication channels is provided voluntarily. By submitting information, you grant Parimitra Pvt. Ltd. the right to use such information solely for responding to inquiries, evaluating potential engagements, and conducting business communications.

While we implement reasonable safeguards, users are advised not to submit confidential, proprietary, or highly sensitive information through the website. Parimitra Pvt. Ltd. shall not be responsible for the protection of information voluntarily shared beyond reasonable security measures.
      `
    },
    {
      heading: "5. Service Information Disclaimer",
      content: `
Descriptions of services, project summaries, performance metrics, case studies, and other informational materials on this website are provided for general informational purposes only. While we strive to ensure accuracy and relevance, such descriptions do not constitute binding commitments, guarantees, or warranties of specific outcomes.

Actual results may vary depending on numerous factors including project scope, implementation conditions, external variables, and client collaboration. Users should not rely solely on website content when making business decisions.
      `
    },
    {
      heading: "6. Limitation of Liability",
      content: `
To the fullest extent permitted by applicable law, Parimitra Pvt. Ltd. shall not be liable for any direct, indirect, incidental, consequential, special, or punitive damages arising out of or related to your access to or use of this website. This includes, but is not limited to, damages resulting from errors, interruptions, inaccuracies, loss of data, or unauthorized access.

The website is provided on an "as is" and "as available" basis without warranties of any kind, whether express or implied. Your use of the website is entirely at your own risk.
      `
    },
    {
      heading: "7. Third-Party Links",
      content: `
The website may contain links to external platforms, social media channels, or third-party websites for informational convenience. These links are provided solely as a reference and do not imply endorsement, approval, or control by Parimitra Pvt. Ltd.

We are not responsible for the content, security practices, privacy policies, or availability of any third-party websites. Users access external links at their own discretion and risk.
      `
    },
    {
      heading: "8. Modification of Terms",
      content: `
Parimitra Pvt. Ltd. reserves the right to update, modify, or replace these Terms of Service at any time without prior notice. Changes become effective immediately upon posting on this page, unless otherwise stated.

It is your responsibility to review these Terms periodically. Continued use of the website following any updates constitutes acceptance of the revised Terms.
      `
    },
    {
      heading: "9. Governing Law",
      content: `
These Terms of Service shall be governed by and interpreted in accordance with the laws of India. Any disputes arising out of or in connection with the use of this website shall be subject to the exclusive jurisdiction of the competent courts in India.

By using this website, you agree to submit to the jurisdiction of such courts for the resolution of disputes.
      `
    }
  ]
};

export default termsOfServiceContent;